'use client';
import PrimaryButton from './PrimaryButton';
import { useRouter } from 'next/navigation';

export default function BackButton() {
  const router = useRouter();
  const handleBack = () => {
    router.back();
  };

  return <PrimaryButton onClick={handleBack} text="Volver" primary={false} />;
}
